// extracted by mini-css-extract-plugin
export default {"root":"VacationModePage_root__fBO1G","content":"VacationModePage_content__pLEPi","heading":"VacationModePage_heading__-yx+g","intro":"VacationModePage_intro__3qFnf"};